import { Box } from '@mui/material';
import RichText from '../index';
import { MarkdownCallout } from '@jd/platform-config';
import { DeepNullToUndefined } from '@jd/client/utils/unnulable';

const CalloutPanel = ({ content }: DeepNullToUndefined<MarkdownCallout>) => {
  return (
    <Box
      className={'tb-callout-container'}
      sx={{
        display: 'inline-block',
        width: '100%',
        border: '4px solid gray',
        borderColor: 'secondary.main',
        borderRadius: { xs: 0.5, md: 1 },
        px: { xs: 2, md: 4 },
        py: { xs: 3, md: 4 },
        my: { xs: 2, md: 4 },
      }}
    >
      <RichText>{content}</RichText>
    </Box>
  );
};
export default CalloutPanel;
